(() => {
  const query = new URLSearchParams(window.location.search);
  const minuteMode = query.get('dev_labels') === 'minute';
  const enabled = document.body?.dataset.ckDevSectionLabels === 'true' || query.get('dev_labels') === '1' || minuteMode;
  if (!enabled) return;

  const getComponentToken = (element, includeBEMElement = false) => {
    const classes = Array.from(element.classList);
    return classes.find((className) => {
      if (!className.startsWith('ck-') || className.startsWith('ck-dev-') || className.includes('--')) return false;
      return includeBEMElement ? className.includes('__') : !className.includes('__');
    }) || '';
  };

  const sections = document.querySelectorAll('#MainContent > .shopify-section');
  sections.forEach((section, index) => {
    if (section.querySelector(':scope > .ck-dev-section-label')) return;

    const rawId = section.id.replace(/^shopify-section-[^_]+__/, '').replace(/^shopify-section-/, '');
    const name = rawId.replace(/[-_]+/g, ' ').trim() || 'unnamed section';
    const typeClass = Array.from(section.classList).find((className) => className.startsWith('section-')) || 'section';
    const component = getComponentToken(section.querySelector('[class*="ck-"]') || section);
    const label = document.createElement('div');
    label.className = 'ck-dev-section-label';
    label.textContent = String(index + 1).padStart(2, '0') + ' · ' + name + ' · ' + typeClass + (component ? ' · .' + component : '');
    label.setAttribute('aria-hidden', 'true');
    section.classList.add('ck-dev-section-labeled');
    section.prepend(label);

    if (!minuteMode) return;

    section.querySelectorAll('[class*="ck-"]').forEach((element) => {
      const token = getComponentToken(element, true);
      if (!token || element.querySelector(':scope > .ck-dev-detail-label')) return;

      element.classList.add('ck-dev-detail-labeled');
      const detailLabel = document.createElement('div');
      detailLabel.className = 'ck-dev-detail-label';
      detailLabel.textContent = '.' + token;
      detailLabel.setAttribute('aria-hidden', 'true');
      element.prepend(detailLabel);
    });
  });
})();
